import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { environment } from '../../environments/environment';
import { GlobalService } from './global.service';
import type { CHAT_HISTORY, CHAT_INTAKE_FORM_NEW, CHAT_STATUS, CONSULTANT_LIST, END_CHAT, FORM_PREFILL, GET_SUPPORT_CHAT_MESSAGES, GET_WALLET_TRANSACTION, INITIATE_WALLET_RECHARGE, JOIN_QUEUE_CHAT_NEW, LOGIN, PROFILE_DATA, SEND_MSG, SEND_SUPPORT_CHAT_MSG, USER_STATUS_FOR_CALL_CHAT, VERIFY_CUSTOMER_LOGIN, VERIFY_OTP } from './payload';
import { apiConstants } from '../constans/constants.module';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  apiUrl = environment.apiEndPoint;
  versionPrefix = "api/v1/customers/";
  versionPrefixLegalStack = "api/v1/legalstack/";
  constructor(private gS: GlobalService, private http: HttpClient) { }

  private getHeaders() {
    let headers = new HttpHeaders();
    const user = localStorage.getItem('userData');

    if (user) {
      const userData = JSON.parse(user);

      console.log("JWT Token:", userData.authToken);

      if (userData.authToken) {
        headers = headers.set('Authorization', `Bearer ${userData.authToken}`);
        headers = headers.set('id', userData.id.toString());
      } else {
        console.warn("No authToken found in localStorage");
      }
    } else {
      console.warn("No user data found in localStorage");
    }

    return { headers };
  }

  getProductForm(categoryId: any) {
    let apiParam = {
      categoryId: categoryId
    }
    return this.http.get(this.apiUrl + `api/v1/customers/get-product-checkout-form-detail`, {
      params: apiParam
    });
  }

  getpujaCollections(productCategory: any, timeZone: any, pageSize: any) {

    let apiParam = {
      pageNo: 0,
      pageSize: pageSize,
      timeZone: timeZone,
      productCategory: productCategory
    }
    return this.http.get(this.apiUrl + `api/v1/customers/product/list/get`, {

      params: apiParam
    });

  }

  sendOTPEmail(customerId: any, customerEmail: any) {
    let body = new HttpParams();
    body = body.set('customerId', customerId);
    body = body.set('customerEmail', customerEmail);
    return this.http.post(this.apiUrl + this.versionPrefix + `send-otp-to-verif-email`, body);
  }

  verifyEmail(data: VERIFY_OTP) {
    return new Promise((resolve, reject) => {
      let body = new HttpParams();
      body = body.set('userId', data.userId);
      body = body.set('otp', data.otp);
      this.http.post(this.apiUrl + this.versionPrefix + 'verify-otp-to-verif-email', body).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }

  getproductDetails(timeZone: any, productUrl: any) {

    let apiParam = {
      productUrl: productUrl,
      timeZone: "Asia/Kolkata"
    }

    return this.http.get(this.apiUrl + `api/v1/customers/product/detail`, {

      params: apiParam
    });

  }

  getCallFormPrefillData(customerId: any) {

    let apiParam = {
      customerId: customerId,

    }
    return this.http.get<any>(this.apiUrl + this.versionPrefix + `autofill-customer-form-call-data`, { params: apiParam });
  }

  userCallFormSubmit(formData: any) {
    let body = new HttpParams();

    body = body.set('customerId', formData.userId);
    body = body.set('birthDate', formData.birtDate);
    body = body.set('birthTime', formData.birthTime);
    body = body.set('birthPlace', formData.birthPlace);
    body = body.set('customerName', formData.name);
    body = body.set('customerMobile', formData?.customerMobile);
    body = body.set('astrologerId', formData.astrologerId);
    body = body.set('gender', formData.gender);
    body = body.set('countryCode', formData?.countryCode);
    body = body.set('timeZone', formData.zoneType);
    body = body.set('comments', formData.userComment);
    body = body.set('platformType', "WEBSITE");

    body = body.set('isFree', false);
    body = body.set('partnerName', "");
    body = body.set('partnerBirthDate', "");
    body = body.set('partnerGender', "");
    body = body.set('partnerbirthTime', "");
    body = body.set('partnerbirthPlace', "");


    return this.http.post(this.apiUrl + this.versionPrefix + `call/form/submit`, body);

  }

  joinQueueCall(astrologerData: any, orderId: any, formdData: any) {
    let body = new HttpParams();
    body = body.set('astrologerId', astrologerData.id);
    body = body.set('customerId', formdData.userId);
    body = body.set('orderId', orderId);
    body = body.set('callingNumber', formdData?.customerMobile);
    body = body.set('countryCode', formdData?.countryCode);
    body = body.set('timeZone', formdData.zoneType);
    body = body.set('platformType', "WEBSITE");
    return this.http.post(this.apiUrl + this.versionPrefix + `start/call/initate`, body);
  }

  getAllProductsByCategory(customerId: any) {

    let apiParam = {
      timeZone: this.gS.timeZone,
      platformType: this.gS.PlatformType,
      appVersion: "1.0",
      customerId: customerId,
      projectId: this.gS.projectId,
    }
    return this.http.get(this.apiUrl + `api/v1/customers/astrohub-home-data`, {

      params: apiParam
    });

  }


  userMobileLogin(data: LOGIN) {
    return new Promise((resolve, reject) => {
      let body = new HttpParams();
      body = body.set('countryCode', data.countryCode);
      body = body.set('customerMobile', data.customerMobile);
      body = body.set('notificationId', data.notificationId);
      body = body.set('platformType', data.platformType);
      body = body.set('timeZone', data.timeZone);
      body = body.set('appVersion', data.appVersion);
      body = body.set('projectId', data.projectId);

      this.http.post(this.apiUrl + this.versionPrefix + 'login/customer/by/mobile', body).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }


  verifyOtp(data: VERIFY_OTP) {
    return new Promise((resolve, reject) => {
      let body = new HttpParams();
      body = body.set('userId', data.userId);
      body = body.set('otp', data.otp);

      this.http.post(this.apiUrl + this.versionPrefix + 'verify-otp-to-verif-mobile', body).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }


  userLoginEmail(formData: any) {
    console.log(formData);
    let body = new HttpParams();
    body = body.set('customerEmail', formData.email);
    body = body.set('platformType', formData.platformType);
    body = body.set('timeZone', this.gS.timeZone);
    body = body.set('projectId', this.gS.projectId);

    return this.http.post(this.apiUrl + this.versionPrefix + `login/customer/by/email`, body);
  }


  verifyMobileOTP(formData: any) {
    let body = new HttpParams();
    body = body.set('userId', formData.userId);
    body = body.set('otp', formData.otp);

    return this.http.post(this.apiUrl + this.versionPrefix + `verify-otp-to-verif-mobile`, body);
  }


  getAstroList(timeZone: any, typeId: any, customerId: any, searchQuery: any, pageNo: any, pageSize: any) {

    let apiParam = {

    }

    if (customerId) {
      apiParam = {
        pageNo: pageNo,
        pageSize: pageSize,
        platformType: this.gS.PlatformType,
        moduleName: typeId,
        sortBy: false,
        projectId: this.gS.projectId,
        sortType: 1,
        timeZone: timeZone,
        customerId: customerId,
        searchQuery: searchQuery,
      }
    } else {
      apiParam = {
        pageNo: pageNo,
        pageSize: pageSize,
        platformType: this.gS.PlatformType,
        moduleName: typeId,
        sortBy: false,
        projectId: this.gS.projectId,
        filterType: 1,
        timeZone: this.gS.timeZone,
        searchQuery: searchQuery,
      }
    }

    return this.http.get<any>(this.apiUrl + this.versionPrefix + `get/all/active/astrologers`, { params: apiParam });

  }

  getLawyerList(payload: CONSULTANT_LIST) {
    return new Promise((resolve, reject) => {
      let apiParam = {
        pageNo: payload.pageNo,
        pageSize: payload.pageSize,
        platformType: payload.platformType,
        moduleName: payload.moduleName,
        sortBy: payload.sortBy,
        projectId: payload.projectId,
        sortType: payload.sortType,
        timeZone: payload.timeZone,
        customerId: payload.customerId,
        searchQuery: payload.searchQuery,
      }
      this.http.get(this.apiUrl + this.versionPrefix + `get/all/active/astrologers`, { params: apiParam }).subscribe({
        next: (res: any) => { resolve(res) },
        error: (error: any) => { reject(error) }
      })
    })

  }


  getAstrologerProfile(payload: PROFILE_DATA) {

    let apiParam = {
      timeZone: payload.timeZone,
      profileUrl: payload.profileUrl,
      projectId: payload.projectId
    }
    return this.http.get<any>(this.apiUrl + this.versionPrefix + `astrologer-detail-get`, { params: apiParam });

  }

  updatecustomerdetail(formData: any) {
    let body = new HttpParams()
      .set('customerName', formData.fullName)
      .set('customerEmail', formData.email)
      .set('customerMobile', formData.mobileNumber)
      .set('countryCode', formData.countryCode) // Ensure country code is included
      .set('gender', formData.gender)
      .set('birthDate', formData.dob)
      .set('profilePic', formData.profilePic)
      .set('customerId', this.gS.userData?.id);

    return this.http.post(this.apiUrl + this.versionPrefix + `update-customer-profile`, body, this.getHeaders());
  }



  getcustomerdetail(customerId: any) {
    let apiParam = {
      customerId: customerId,
    };

    return this.http.get(this.apiUrl + this.versionPrefix + `get-customer-detail`, {
      params: apiParam,
      headers: this.getHeaders().headers,
    });
  }

  veifyCustomerLogin(data: VERIFY_CUSTOMER_LOGIN) {
    return new Promise((resolve, reject) => {
      let body = new HttpParams();
      body = body.set('customerId', data.customerId);

      let header = new HttpHeaders();
      if (data.token) {
        header = header.set('Authorization', `Bearer ${data.token}`);
        header = header.set('id', data.customerId);
      }

      console.log(header,'payload');
      

      this.http.post(this.apiUrl + this.versionPrefixLegalStack + 'verify-customer-login-book-service', body,{
        headers:header
      }).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          resolve(err)
        }
      })
    })
  }



  imageUpload(image: any) {

    let body = new HttpParams();

    body = body.set('image', image);
    body = body.set('extension', "png");


    return this.http.post(this.apiUrl + `image/upload`, image);


  }



  submitPujaOrderForm(formData: any) {

    let body = new HttpParams();

    body = body.set('customerName', formData.customerName);
    body = body.set('customerEmail', formData.customerEmail);
    body = body.set('customerMobile', formData.customerMobile?.number);
    body = body.set('birthDate', formData.birtDate);
    body = body.set('birthPlace', formData.birthPlace);
    body = body.set('platformType', "WEBSITE");
    body = body.set('timeZone', this.gS.timeZone);
    body = body.set('comments', formData.comments);
    body = body.set('customerId', formData.userId);
    body = body.set('productId', formData.productId);
    body = body.set('incomeTaxId', formData.incomeTaxId);
    body = body.set('panCardNumber', formData.panCardNumber);
    body = body.set('assessmentYear', formData.assessmentYear);
    body = body.set('projectId', this.gS.projectId);


    console.log(body);


    return this.http.post(this.apiUrl + this.versionPrefix + `product-checkout-submit`, body);

  }


  confirmPujaOrder(formData: any) {

    let body = new HttpParams();

    body = body.set('orderId', formData.orderId);
    body = body.set('platformType', "WEBSITE");
    body = body.set('appVersion', "1.0.0");
    body = body.set('timeZone', this.gS.timeZone);
    body = body.set('orderAmount', formData.productPrice);
    body = body.set('customerId', formData.userId);



    return this.http.post(this.apiUrl + this.versionPrefix + `product-order-payment-confirmation`, body);


  }


  getUserWalletAmount(userid: any, pageSize: any) {


    let apiParam = {
      customerId: userid,
      pageNo: 0,
      pageSize: pageSize,
    }
    return this.http.get(this.apiUrl + this.versionPrefix + `get/wallet/transaction`, { params: apiParam, headers: this.getHeaders().headers, });
  }

  generateHash() {

    let apiParam = {
      domain_name: 'https://legalstack.in',
      secret_id: 1,
    }
    return this.http.get(this.apiUrl + 'api/v1/legalstack/' + `legalstack_generate_auth_hash`, { params: apiParam, headers: this.getHeaders().headers, });
  }

  getTransactionHistory(userid: any, pageSize: any, pageNo: any) {
    let apiParam = {
      customerId: userid,
      pageNo: pageNo,
      pageSize: pageSize,
    }
    return this.http.get(this.apiUrl + this.versionPrefix + `get/wallet/transaction`, { params: apiParam, headers: this.getHeaders().headers, });
  }


  getPalmOrderHistory(userid: any, pageSize: any) {


    let apiParam = {
      customerId: userid,
      pageNo: 0,
      pageSize: pageSize,
      timeZone: this.gS.timeZone
    }
    return this.http.get(this.apiUrl + this.versionPrefix + `get/get-palm-order-history`, { params: apiParam, headers: this.getHeaders().headers, });
  }

  submitratereview(formData: any) {

    let body = new HttpParams();
    {
      body = body.set('customerReview', formData.customerReview);
      body = body.set('customerRating', formData.customerRating);
      body = body.set('orderId', formData.orderId);
    }
    return this.http.post(this.apiUrl + this.versionPrefix + formData?.path, body, this.getHeaders());

  }



  getChatOrderHistory(userId: any, pageSize: any) {
    let apiParam = {
      customerId: userId,
      pageNo: 0,
      pageSize: pageSize,
      timeZone: this.gS.timeZone
    }
    return this.http.get(this.apiUrl + this.versionPrefix + `get-chat-order-listing`, { params: apiParam, headers: this.getHeaders().headers, });
  }


  getChatOrderHistoryNew(userId: any, pageSize: any, pageNo: any) {
    let apiParam = {
      customerId: userId,
      pageNo: pageNo,
      pageSize: pageSize,
      timeZone: this.gS.timeZone
    }
    return this.http.get(this.apiUrl + this.versionPrefix + `get-chat-order-listing`, { params: apiParam, headers: this.getHeaders().headers, });
  }


  getReportOrderDetails(userid: any, pageSize: any) {


    let apiParam = {
      customerId: userid,
      pageNo: 0,
      pageSize: pageSize,
      timeZone: this.gS.timeZone

    }
    return this.http.get(this.apiUrl + this.versionPrefix + `get-horoscope-order-history`, { params: apiParam, headers: this.getHeaders().headers, });
  }


  viewChatOrderHistory(data: any) {
    let apiParam = {
      customerId: data.customerId,
      orderId: data.orderId,
      pageNo: data.pageNo,
      pageSize: data.pageSize,
    }
    return this.http.get(this.apiUrl + this.versionPrefix + `get-chat-messaging-history`, { params: apiParam, headers: this.getHeaders().headers, });

  }



  getCallOrderHistoryNew(userId: any, pageSize: any, pageNo: any) {
    let apiParam = {
      customerId: userId,
      pageNo: pageNo,
      pageSize: pageSize,
      timeZone: this.gS.timeZone
    }
    return this.http.get(this.apiUrl + this.versionPrefix + `get-call-order-history`, { params: apiParam, headers: this.getHeaders().headers, });
  }

  getCallOrderHistory(userId: any, pageSize: any) {
    let apiParam = {
      customerId: userId,
      pageNo: 0,
      pageSize: pageSize,
      timeZone: this.gS.timeZone
    }
    return this.http.get(this.apiUrl + this.versionPrefix + `get-call-order-history`, { params: apiParam, headers: this.getHeaders().headers, });
  }

  getChangeReportOrderViewStatus(data: any) {


    let apiParam = {
      userId: data.userid,
      orderId: data.orderid,

    }
    return this.http.get(this.apiUrl + this.versionPrefix + `change-report-order-view-status`, { params: apiParam, headers: this.getHeaders().headers, });
  }


  getReportOrderData(qid: any) {


    let apiParam = {
      orderId: qid,
      timeZone: this.gS.timeZone

    }
    return this.http.get(this.apiUrl + this.versionPrefix + `get-horoscope-order-history`, { params: apiParam, headers: this.getHeaders().headers, });
  }

  getProductOrderHistoryNew(userid: any, pageSize: any, pageNo: any) {

    let apiParam = {
      customerId: userid,
      pageNo: pageNo,
      pageSize: pageSize,
      timeZone: this.gS.timeZone
    }
    return this.http.get(this.apiUrl + this.versionPrefix + `get-product-order-history`, { params: apiParam, headers: this.getHeaders().headers, });
  }

  getProductChatUserList(userid: any, pageSize: any, pageNo: any, projectId: any) {

    let apiParam = {
      userId: userid,
      pageNo: pageNo,
      pageSize: pageSize,
      projectId: projectId
    }
    return this.http.get(this.apiUrl + this.versionPrefix + `get_product_order_chat_list`, { params: apiParam, headers: this.getHeaders().headers, });
  }

  markProductOrderChatMsgRead(data: any) {
    let apiParam = {
      orderId: data.orderId
    }

    return this.http.get(this.apiUrl + this.versionPrefix + `mark_product_chat_msg_read`, { params: apiParam, headers: this.getHeaders().headers, });
  }

  getProductOrderChatMsg(data: any) {
    let apiParam = {
      customerId: data.customerId,
      advisorProductId: data.advisorProductId,
    }

    return this.http.get(this.apiUrl + this.versionPrefix + `get_product_chat_msg_customer`, { params: apiParam, headers: this.getHeaders().headers, });
  }

  getSavedAttachmentList(data: any) {
    let apiParam = {
      userId: data.userId,
    }

    return this.http.get(this.apiUrl + this.versionPrefix + `get_attachment_by_user_id`, { params: apiParam, headers: this.getHeaders().headers, });
  }

  sendProductOrderChatMsg(data: any) {

    return this.http.post(this.apiUrl + this.versionPrefix + `send_product_chat_msg`, data, this.getHeaders());
  }

  getRechargeAmount(userid: any) {
    let apiParam = {
      customerId: userid,
      timeZone: "Asia/Kolkata"
    }
    return this.http.get(this.apiUrl + this.versionPrefix + `wallet/reacharge/amount/list`, { params: apiParam, headers: this.getHeaders().headers, });
  }

  startPaymentInitate(formData: any) {

    let body = new HttpParams();

    body = body.set('customerId', formData.userId);
    body = body.set('rechargeAmount', formData.amount);
    body = body.set('taxAmount', formData.gst);
    body = body.set('timeZone', this.gS.timeZone);
    body = body.set('offerId', -1);
    body = body.set('discount', formData.discount ? formData.discount : 0);
    body = body.set('platformType', apiConstants.PlatformType);
    body = body.set('finalAmount', 1);
    body = body.set('projectId', this.gS.projectId);
    return this.http.post(this.apiUrl + this.versionPrefix + `wallet/recharge/start`, body, this.getHeaders());
  }


  completePayment(formData: any) {

    let body = new HttpParams();
    body = body.set('paymentId', formData.txID);
    body = body.set('paymentStatus', 'COMPLETED');
    body = body.set('razorPayTransactionId', formData.paymentGatewayTxID);
    return this.http.post(this.apiUrl + this.versionPrefix + `wallet/recharge/success`, body, this.getHeaders());

  }


  checkCouponAvailability(data: any) {
    let apiParam = new HttpParams();
    apiParam = apiParam.set('customerId', data.customerId);
    apiParam = apiParam.set('amount', data.amount);
    apiParam = apiParam.set('couponCode', data.couponCode);
    apiParam = apiParam.set('platformType', data.platformType);
    apiParam = apiParam.set('timezone', this.gS.timeZone);

    return this.http.post(this.apiUrl + `api/v1/customers/check-coupon-availability`, apiParam, this.getHeaders());
  }

  checkRunningCallChat(userId: any) {
    let body = {
      customerId: userId
    };
    return this.http.get(this.apiUrl + this.versionPrefix + `get-active-call-chat`, { params: body, headers: this.getHeaders().headers, });
  }


  cancelChatCall(userId: any) {

    let body = new HttpParams();
    body = body.set('customerId', userId);
    return this.http.post(this.apiUrl + this.versionPrefix + `cancel-chat-request`, body, this.getHeaders());
  }


  userAstrologerChatAccept(chatOrderId: any) {



    let body = new HttpParams();

    body = body.set('chatOrderId', chatOrderId);

    let apiParam = {
      chatOrderId: chatOrderId,

    }

    console.log(body);

    return this.http.post(this.apiUrl + `api/v1/receive/chat/by/user`, body, this.getHeaders());
  }

  getAllCoupon(userId: any, timeZone: any) {

    let apiParam = {
      customerId: userId,
      platformType: apiConstants.PlatformType,
      timezone: this.gS.timeZone,

    }
    return this.http.get(this.apiUrl + `api/v1/customers/get-coupon-code-offer?`, {
      params: apiParam,
      headers: this.getHeaders().headers,
    });
  }


  getWalletTransaction(data: GET_WALLET_TRANSACTION) {
    return new Promise((resolve, reject) => {
      let apiParam = {
        customerId: data.customerId,
        pageNo: data.pageNo,
        pageSize: data.pageSize,
        projectId: data.projectId
      }
      this.http.get(this.apiUrl + this.versionPrefix + 'get/wallet/transaction', {
        params: apiParam,
        headers: this.getHeaders().headers,
      }).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }


  checkCallStatus(data: USER_STATUS_FOR_CALL_CHAT) {

    return new Promise((resolve, reject) => {
      let apiParam = new HttpParams();

      apiParam = apiParam.set('astrologerId', data.consultantId);
      apiParam = apiParam.set('customerId', data.userId);
      apiParam = apiParam.set('timeZone', data.timezone);
      apiParam = apiParam.set('platformType', "WEBSITE");
      apiParam = apiParam.set('appVersion', "1.0");

      this.http.post(this.apiUrl + this.versionPrefix + `check-call-status-before-start-new-call`, apiParam).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })

    });


  }


  userStatusForCallChat(data: USER_STATUS_FOR_CALL_CHAT) {
    return new Promise((resolve, reject) => {
      let apiParam = new HttpParams();
      apiParam = apiParam.set('consultantId', data.consultantId);
      apiParam = apiParam.set('userId', data.userId);
      apiParam = apiParam.set('timezone', data.timezone);
      apiParam = apiParam.set('isCall', data.isCall);
      apiParam = apiParam.set('appId', data.appId);
      apiParam = apiParam.set('businessId', data.businessId);
      apiParam = apiParam.set('appVersionUser', data.appVersionUser);
      apiParam = apiParam.set('isPo', data.isPo);

      this.http.post(this.apiUrl + 'api/astroapp/secure/v2/getuser/status/for/call/chat', apiParam, this.getHeaders()).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }



  chatFormPrefill(data: FORM_PREFILL) {
    return new Promise((resolve, reject) => {

      let apiParam = {
        customerId: data.customerId,
      }

      this.http.get(this.apiUrl + this.versionPrefix + 'autofill-customer-form-chat-data', { params: apiParam, headers: this.getHeaders().headers, }).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }


  chatIntakeFormNew(data: CHAT_INTAKE_FORM_NEW) {
    return new Promise((resolve, reject) => {
      let body = new HttpParams();
      body = body.set('customerId', data.customerId);
      body = body.set('birthDate', data.birthDate);
      // body = body.set('birthTime', data.birthTime);
      body = body.set('birthPlace', data.birthPlace);
      body = body.set('customerName', data.customerName);
      body = body.set('astrologerId', data.astrologerId);
      body = body.set('gender', data.gender);
      body = body.set('timeZone', data.timeZone);
      body = body.set('comments', data.comments);
      body = body.set('platformType', data.platformType);
      body = body.set('isFree', data.isFree);
      // body = body.set('partnerName', data.partnerName);
      // body = body.set('partnerGender', data.partnerGender);
      // body = body.set('partnerBirthDate', data.partnerBirthDate);
      // body = body.set('partnerbirthPlace', data.partnerbirthPlace);
      // body = body.set('partnerbirthTime', data.partnerbirthTime);

      this.http.post(this.apiUrl + this.versionPrefix + 'chat/form/submit', body, this.getHeaders()).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }



  joinQueueChatNew(data: JOIN_QUEUE_CHAT_NEW) {
    return new Promise((resolve, reject) => {
      let body = new HttpParams();
      body = body.set('astrologerId', data.astrologerId);
      body = body.set('customerId', data.customerId);
      body = body.set('orderId', data.orderId);
      body = body.set('timeZone', data.timeZone);
      body = body.set('platformType', data.platformType);
      body = body.set('appVersion', data.appVersion);
      body = body.set('isFree', data.isFree);

      this.http.post(this.apiUrl + this.versionPrefix + 'start/chat/initate/v2', body, this.getHeaders()).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }


  initiateWalletRecharge(data: INITIATE_WALLET_RECHARGE) {
    return new Promise((resolve, reject) => {
      let body = new HttpParams();
      body = body.set('customerId', data.customerId);
      body = body.set('finalAmount', data.finalAmount);
      body = body.set('offerId', data.offerId);
      body = body.set('discount', data.discount);
      body = body.set('paymentType', data.paymentType);
      body = body.set('platformType', data.platformType);
      body = body.set('rechargeAmount', data.rechargeAmount);
      body = body.set('taxAmount', data.taxAmount);
      body = body.set('timeZone', data.timeZone);

      this.http.post(this.apiUrl + this.versionPrefix + 'wallet/recharge/start', body, this.getHeaders()).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }

  getAllExpertiseList() {

    return this.http.get<any>(this.apiUrl + `api/v1/astrologer/get-all-expertise-languages`, {});

  }

  astrologerRegister(formData: any) {

    let body = new HttpParams();
    body = body.set('astrologerName', formData.astrologerName);
    body = body.set('aboutMe', formData.aboutMe);
    body = body.set('alternateMobileNumber', formData.alternateMobileNumber);
    body = body.set('emailAddress', formData.emailAddress);
    body = body.set('expertiseArea', formData.expertiseArea);
    body = body.set('knownLanguage', formData.knownLanguage);
    body = body.set('profilePic', formData.profilePic);
    body = body.set('gender', formData.gender);

    body = body.set('mobileNumber', formData.mobileNumber);
    body = body.set('workExperince', formData.workExperince);

    return this.http.post(this.apiUrl + `api/v1/astrologer/register-new-astrologer`, body);
  }

  getSupportChatMessages(data: GET_SUPPORT_CHAT_MESSAGES) {
    return new Promise((resolve, reject) => {
      let apiParam = {
        pageNo: data.pageNo,
        pageSize: data.pageSize,
        customerId: data.customerId
      }

      this.http.get(this.apiUrl + this.versionPrefix + 'get-customer-support-chat-message-list', { params: apiParam }).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }

  sendSupportChatMsg(data: SEND_SUPPORT_CHAT_MSG) {
    return new Promise((resolve, reject) => {
      let body = new HttpParams();
      body = body.set('message', data.message);
      body = body.set('mediaType', data.mediaType);
      body = body.set('senderId', data.senderId);
      body = body.set('receiverId', data.receiverId);

      this.http.post(this.apiUrl + this.versionPrefix + 'send-customer-support-message-reply', body).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }

  emailValidation(formData: any) {
    console.log(formData);
    let body = new HttpParams();
    body = body.set('customerEmail', formData.email);
    body = body.set('timeZone', this.gS.timeZone);
    body = body.set('projectId', this.gS.projectId);

    return this.http.post(this.apiUrl + `api/v1/subscribe/news/letter`, formData);
  }


  chatHistory(data: CHAT_HISTORY) {

    return new Promise((resolve, reject) => {

      let apiParam = {
        orderId: data.orderId,
        pageNo: data.pageNo,
        pageSize: data.pageSize,
        customerId: data.customerId
      }

      this.http.get(this.apiUrl + this.versionPrefix + 'get-chat-messaging-history', { params: apiParam }).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }



   sendChatMessage(data: SEND_MSG) {

    return new Promise((resolve, reject) => {

      let body = new HttpParams();
      body = body.set('chatMessage', data.chatMessage);
      body = body.set('orderId', data.orderId);
      body = body.set('senderId', data.senderId);
      body = body.set('receiverId', data.receiverId);
      body = body.set('messageType', data.messageType);
      body = body.set('replyMsgId', data.replyMsgId);

      this.http.post(this.apiUrl + this.versionPrefix + 'send-message', body).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }


   getChatStatus(data: CHAT_STATUS) {

    return new Promise((resolve, reject) => {
      let apiParam = {
        orderId: data.orderId,
      }

      this.http.get(this.apiUrl + this.versionPrefix + 'get-chat-order-status', { params: apiParam }).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }

  endChat(data: END_CHAT) {

    return new Promise((resolve, reject) => {

      let body = new HttpParams();
      body = body.set('chatOrderId', data.chatOrderId);

      this.http.post(this.apiUrl + this.versionPrefix + 'end-chat-by-customer', body).subscribe({
        next: (res: any) => {
          resolve(res);
        }, error(err) {
          reject(err)
        }
      })
    })
  }

}
